query ListMyAssets {
  assets: StreamToolsListMyAssets {
    assetId
    fileName
    contentType
    sizeBytes
    publicUrl
    createdAt
    references {
      elementKind
      elementId
      elementName
      eventId
      eventName
    }
    usedByMerchBoards
    usedByTickerBars {
      tickerBarId
      name
    }
    replacedByAssetId
    replacedAt
    replacesAssetId
  }
}
